export const COUNTRY_CODES = {
    PL: 'Poland',
    IN: 'India',
    UK: 'United Kingdom',
    MY: 'Malaysia',
    NL: 'Holland',
    DK: 'Denmark',
    DE: 'Germany',
    CH: 'Switzerland',
};